﻿<template>
  <a-config-provider :theme="arcoTheme">
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useThemeStore } from '@/store/theme'

const themeStore = useThemeStore()
themeStore.initTheme()

const arcoTheme = computed(() => ({
  name: themeStore.theme.darkMode ? 'dark' : 'light',
}))
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
